// Native
import { useState } from "react"
import { useParams } from "react-router"

// Components
import { ButtonGroup, Tag, Td, Badge, Tooltip } from "@chakra-ui/react"
import { Form, IconButton, Row, Searchable, Section, Table } from "components"

// Config
import { Enums, Moment, Mask } from "config"

// Hooks
import { useDistributor, useDistributorShopping, useScreens } from "hooks"

export default function Shopping(){

    const params = useParams()
    const distributor = useDistributor(params?.id)
    const { setOrder } = useScreens()
    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState()
    const [ status, setStatus ] = useState()
    const [ type, setType ] = useState()
    const orders = useDistributorShopping(distributor.data?.id, page, term, status, type)

    const columns = [
        { children: '' },
        { children: 'Status' },
        { children: 'Tipo de envio' },
        { children: 'Valor', isNumeric: true },
        { children: 'Data', isNumeric: true },
        { children: '', isNumeric: true }
    ]

    return(
        <>
            <Section title="Compras de produtos">
                <ButtonGroup size="xs" isDisabled={orders.isFetching}>
                    <IconButton icon="refresh" isLoading={orders.isFetching} onClick={orders.refetch} />
                </ButtonGroup>
            </Section>

            <Searchable value={term} setValue={setTerm} placeholder="Pesquisar por ID ou Código do pedido..">
                <Form.Select onChange={e => setType(e.target.value)} options={[{ label: 'Todos os pedidos', value: '' }, { label: 'Pedidos de Consultores', value: Enums.OrderType.CONSULTANT }, { label: 'Pedidos de Voucher', value: Enums.OrderType.VOUCHER }]} />
                <Form.Select onChange={e => setStatus(e.target.value)} options={[{ label: 'Todos os status', value: '' }, { label: 'Aprovado', value: Enums.OrderStatus.APPROVED },{ label: 'Cancelado', value: Enums.OrderStatus.CANCELED }, { label: 'Em Análise', value: Enums.OrderStatus.ANALYZING }, { label: 'Em Trânsito', value: Enums.OrderStatus.SHIPPING }]} />
            </Searchable>

            <Table columns={columns} meta={orders.data?.meta} setPage={setPage} loading={orders.isLoading}>
                { orders.data?.data?.map(item => <Item key={item.id} data={item} onClick={() => setOrder(item)} />)}
            </Table>
        </>
    )
}

const Item = ({ data:item, ...props }) => {

    let shipping_type = Enums.OrderShippingType.data(item.shipping_type)

    return(
        <Row {...props}>
            <Td>
                {item.is_from_old_distributor ? (
                    <Tooltip label="Pedido de núcleo transferido" hasArrow>
                        <Badge colorScheme="purple" variant="subtle" px="2" py="0.5" borderRadius="md">
                            {item.cod}
                        </Badge>
                    </Tooltip>
                ) : item.cod}
            </Td>
            <Td><Tag size="sm" colorScheme={Enums.OrderStatus.data(item.status).colorScheme} children={item.status_label} /></Td>
            <Td>{`${shipping_type.emoji} ${shipping_type.label}`}</Td>
            <Td isNumeric>R$ {Mask.price(item.total_amount)}</Td>
            <Td fontSize="xs" isNumeric>{Moment(item.created_at).calendar()}</Td>
            <Td isNumeric><IconButton size="xs" label="Ver pedido" icon="view" /></Td>
        </Row>
    )}
